/* eslint-disable import/prefer-default-export */
import client from '../apollo';

export const customMutation = async (mutation, variables) => {
  const result = await client.mutate({ mutation, variables });
  return result;
};
